import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import * as icon from "@coreui/icons";

// components
import { CButton } from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from '../../components/details/invoice-details/AppDetails'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview'
import AppModalConfirmation from '../../components/modal/AppModalConfirmation'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'

// helpers
import Axios from 'src/helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const InvoiceDetails = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { showError } = useToastMessage();
  const params = useParams()
  const { id } = params

  const isLoading = useSelector((state) => state.isLoading)

  const [invoiceDetails, setInvoiceDetails] = useState('')
  
  const [openFilePreview, setOpenFilePreview] = useState(false)

  const [showConfirmationGenerateModal, setShowConfirmationGenerateModal] = useState({ show: false })

  const handleCardHeaderButton = () => {
    navigate(`/invoice/edit/${id}`)
  }

  const handleCardHeaderOtherButton = () => {
    setShowConfirmationGenerateModal({ show: !showConfirmationGenerateModal.show })
  }
  
  const handleGeneratePDF = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/invoice/generate-pdf/${id}`,
    })
      .then(({ data }) => {
        const { success } = data || {}
        if (success) {
          fetchInvoiceDetails()
          setShowConfirmationGenerateModal({ show: !showConfirmationGenerateModal.show })
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
        setTimeout(() => {
          setShowConfirmationGenerateModal({ show: !showConfirmationGenerateModal.show })
        }, 1000)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  useEffect(() => {
    fetchInvoiceDetails()
  }, [id]);

  const fetchInvoiceDetails = () => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/invoice/${id}`,
    })
      .then(({ data }) => {
        const { success, value } = data || {}
        if (success) {
          let invoiceValue = value
          let recipientsValue = invoiceValue?.recipients || []

          if (recipientsValue.length > 0) {
            recipientsValue = recipientsValue?.map((e) => {
              return {
                ...e,
                phone_number: e?.recipient_contact_number,
                country_value: JSON.stringify({
                  id: e?.country_value?.id,
                  name: e?.country_value?.name,
                  icon: icon[`cif${e?.country_value?.country_code}`],
                  phone_code: e?.country_value?.phone_code
                })
              }
            })
          }

          invoiceValue.recipients = recipientsValue

          setInvoiceDetails(invoiceValue)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      {
        showConfirmationGenerateModal.show && (
          <AppModalConfirmation 
            confirmationType="confirmation"
            showModal={showConfirmationGenerateModal}
            setShowModal={setShowConfirmationGenerateModal}
            headerTitle="Confirmation"
            descriptionText="Are you sure want to generate pdf of this invoice?"
            handleSubmit={handleGeneratePDF}
            isLoading={isLoading}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/invoice/list')}>
          Back
        </CButton>
      </div>
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Invoice Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
            headerOtherButton={invoiceDetails?.recipients?.length == invoiceDetails?.generate_pdf_attachments?.length ? '' : 'Generate PDF'}
            handleCardHeaderOtherButton={handleCardHeaderOtherButton}
          />
        }
        bodyContent={
          <AppDetails
            invoiceDetails={invoiceDetails}
            handleViewFile={setOpenFilePreview}
          />
        }
        lowerBodyContent={
          <>
            <AppCard 
              className='mb-4'
              headerTitle={
                <AppCardHeader
                  headerTitle={<h4>Generated Invoice</h4>}
                />
              }
              bodyContent={
                <>
                  {
                    invoiceDetails?.generate_pdf_attachments?.length > 0 ? (
                      <FormFileThumbnail 
                        name='invoice_attachments'
                        colSize='6'
                        files={invoiceDetails?.generate_pdf_attachments}
                        className='justify-content-start align-items-center'
                        handleViewFile={setOpenFilePreview}
                        isDetailPage={true}
                      />
                    )
                    : (
                      <>Not Found</>
                    )
                  } 
                </>
              }
            />
            <AppCard 
              className='mb-4'
              headerTitle={
                <AppCardHeader
                  headerTitle={<h4>Attachments</h4>}
                />
              }
              bodyContent={
                <>
                  {
                    invoiceDetails?.attachments?.length > 0 ? (
                      <FormFileThumbnail 
                        name='invoice_attachments'
                        colSize='6'
                        files={invoiceDetails?.attachments}
                        className='justify-content-start align-items-center'
                        handleViewFile={setOpenFilePreview}
                        isDetailPage={true}
                      />
                    )
                    : (
                      <>Not Found</>
                    )
                  } 
                </>
              }
            />
          </>
        }
      />
    </>
  )
}

export default InvoiceDetails
